import { useNavigate } from 'react-router-dom'

import { LayoutPage } from '../LayoutPage'

import './index.css'

const FooterComponent = () => {
    const navigate = useNavigate()

    const handleClickLogout = () => {
        navigate('/logout')
    }

    return (
        <div className="c-Footer">
            <LayoutPage>
                <ul className="footer-navUser">
                    <li onClick={handleClickLogout}>Logout</li>
                </ul>
            </LayoutPage>
        </div>
    )
}

export { FooterComponent }
